export default {
  carBrand: (state) => {
    return state.carBrand;
  },
  carBrandOptions: (state) => {
    const carBrandOptions = [];
    state.carBrand.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      carBrandOptions.push(pushItem);
    }
    return carBrandOptions;
  },

  carModel: (state) => {
    return state.carModel;
  },
  carModelOptions: (state) => {
    const carModelOptions = [];
    if (state.carModel && state.carModel.carModels) {
      state.carModel.carModels.forEach((item) => {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        carModelOptions.push(pushItem);
      });
    }
    return carModelOptions;
  },
  province: (state) => {
    return state.province;
  },
  provinceOptions: (state) => {
    const provinceOptions = [];
    state.province.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },
  city: (state) => {
    return state.city;
  },
  cityOptions: (state) => {
    const cityOptions = [];
    state.city.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityOptions.push(pushItem);
    }
    return cityOptions;
  },

  services: (state) => {
    return state.services;
  },

  customerBanners: (state) => {
    return state.customerBanners;
  },

  blogHome: (state) => {
    return state.blogHome;
  },
  blog: (state) => {
    return state.blog;
  },

  socials: (state) => {
    return state.socials;
  },

  products: (state) => {
    return state.products;
  },

  productsListPage: (state) => {
    return state.productsListPage;
  },

  productsOptions: (state) => {
    const productsOptions = [];
    state.products.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      productsOptions.push(pushItem);
    }
    return productsOptions;
  },

  category: (state) => {
    return state.category;
  },
  categoryOptions: (state) => {
    const categoryOptions = [];
    state.category.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        parentId: item.parentId,
      };
      categoryOptions.push(pushItem);
    }
    return categoryOptions;
  },



  ringFeature: (state) => {
    return state.ringFeature;
  },
  ringFeatureOptions: (state) => {
    const ringFeatureOptions = [];
    if (state.ringFeature && state.ringFeature.featureDetails) {
      state.ringFeature.featureDetails.forEach((item) => {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        ringFeatureOptions.push(pushItem);
      });
    }
    return ringFeatureOptions;
  },

  wideFeature: (state) => {
    return state.wideFeature;
  },
  wideFeatureOptions: (state) => {
    const wideFeatureOptions = [];
    if (state.wideFeature && state.wideFeature.featureDetails) {
      state.wideFeature.featureDetails.forEach((item) => {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        wideFeatureOptions.push(pushItem);
      });
    }
    return wideFeatureOptions;
  },

  ratioFeature: (state) => {
    return state.ratioFeature;
  },
  ratioFeatureOptions: (state) => {
    const ratioFeatureOptions = [];
    if (state.ratioFeature && state.ratioFeature.featureDetails) {
      state.ratioFeature.featureDetails.forEach((item) => {
        const pushItem = {
          value: item.id,
          text: item.title,
        };
        ratioFeatureOptions.push(pushItem);
      });
    }
    return ratioFeatureOptions;
  },

  productDetail: (state) => {
    return state.productDetail;
  },

  similarProducts: (state) => {
    return state.similarProducts;
  },

  tabOneProducts: (state) => {
    return state.tabOneProducts;
  },
  tabTwoProducts: (state) => {
    return state.tabTwoProducts;
  },
  tabThreeProducts: (state) => {
    return state.tabThreeProducts;
  },

  dynamicPageContent: (state) => {
    return state.dynamicPageContent;
  },

  ticketCategory: (state) => {
    return state.ticketCategory;
  },
  ticketCategoryOptions: (state) => {
    const ticketCategoryOptions = [];
    state.ticketCategory.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      ticketCategoryOptions.push(pushItem);
    }
    return ticketCategoryOptions;
  },

  blogs: (state) => {
    return state.blogs;
  },

  service: (state) => {
    return state.service;
  },

  faq: (state) => {
    return state.faq;
  },
  aboutUs: (state) => {
    return state.aboutUs;
  },

  brands: (state) => {
    return state.brands;
  },
  brandOptions: (state) => {
    const brandOptions = [];
    state.brands.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      brandOptions.push(pushItem);
    }
    return brandOptions;
  },
  // Static Getters.............................................................................
  sortOptions: () => {
    const sort = [];
    sort.push(
      {
        value: 1,
        text: "جدیدترین",
      },
      {
        value: 2,
        text: "قدیمی ترین",
      },
      {
        value: 3,
        text: "پربازدیدترین",
      },
      {
        value: 4,
        text: "پیشنهاد ما",
      },
      {
        value: 5,
        text: "بیشترین قیمت",
      },
      {
        value: 6,
        text: "کمترین قیمت",
      }
    );
    return sort;
  },
  sortBlogOptions() {
    const options = [
      { value: 1, text: "جدیدترین" },
      { value: 2, text: "پرطرفدارترین" },
      { value: 3, text: "کوتاه‌ترین" },
      { value: 4, text: "طولانی‌ترین" },
      { value: 5, text: "قدیمی‌ترین" },
    ];
    return options;
  },
  relatedBlogs: (state) => {
    return state.relatedBlogs;
  },

  comments: (state) => {
    return state.comments;
  },

  slides: (state) => {
    return state.slides;
  },

  team: (state) => {
    return state.team;
  },

  poster1: (state) => {
    return state.poster1;
  },
  poster2: (state) => {
    return state.poster2;
  },
  posterProducts: (state) => {
    return state.posterProducts;
  },
  posterBlogs: (state) => {
    return state.posterBlogs;
  },
  rules: (state) => {
    return state.rules;
  },
  contactUs: (state) => {
    return state.contactUs;
  },
  faqPage: (state) => {
    return state.faqPage;
  },
};
